module.exports = __webpack_public_path__ + "img/zw_1.d68229d6.jpg";